module.exports = __webpack_public_path__ + "static/media/DarkFae4.70b9860e.png";